import { copyCanvasElement } from '../util/misc/dom';
import type { TSize } from '../typedefs';
import { resolveRasterSource } from './raster-source';
import type {
  EditorRasterLoadOptions,
  EditorRasterSource,
  EditorRasterSourceDescriptor,
} from './types';

const normalizeSize = (size: TSize): TSize => ({
  width: Math.max(Math.round(size.width || 0), 1),
  height: Math.max(Math.round(size.height || 0), 1),
});

export class EditorRasterImage {
  readonly descriptor: EditorRasterSourceDescriptor;
  readonly size: TSize;

  private readonly surface: HTMLCanvasElement;

  constructor(
    surface: HTMLCanvasElement,
    descriptor: EditorRasterSourceDescriptor,
    size: TSize,
  ) {
    this.surface = copyCanvasElement(surface);
    this.descriptor = descriptor;
    this.size = normalizeSize(size);
  }

  static async fromSource(
    source: EditorRasterSource,
    options: EditorRasterLoadOptions = {},
  ): Promise<EditorRasterImage> {
    const resolved = await resolveRasterSource(source, options);
    return new EditorRasterImage(
      resolved.surface,
      resolved.descriptor,
      resolved.size,
    );
  }

  snapshot(): HTMLCanvasElement {
    return copyCanvasElement(this.surface);
  }
}
